"use client"
 
import { Mail } from "lucide-react"
import { FeedbackModal } from "../modals/feedback-modal"
import { useState } from "react"
import { getFooterIdentity } from "../lib/company"


export function Footer() {
  const [isFeedbackModalOpen, setIsFeedbackModalOpen] = useState(false)

  // Entity and year follow the user's recorded location - see lib/company.ts.
  const { companyName, year } = getFooterIdentity()

  const openFeedbackModal = () => setIsFeedbackModalOpen(true)
  const closeFeedbackModal = () => setIsFeedbackModalOpen(false)
 
  return (
    <>
      <footer
        className={`border-t mt-auto relative bg-white border-gray-200 text-gray-600`}
      >
        <div className="max-w-7xl mx-auto px-6 py-6 space-y-6">
          {/* Useful Links */}
          <div className="flex flex-col sm:flex-row items-center justify-center gap-4 sm:gap-8 text-sm">
            <a
              href="https://netorg207568.sharepoint.com/sites/UCITMS-SupportSite/SitePages/CollabHome.aspx?csf=1&web=1&e=amy1UY&CID=f6283b8d-5c3a-4dac-9bbb-3564a4e4b090"
              className="hover:underline"
              target="_blank"
              rel="noopener noreferrer"
            >
              Support Site
            </a>
            <span className="hidden sm:inline">|</span>
            <button
              onClick={openFeedbackModal}
              className="hover:underline cursor-pointer"
            >
              Feedback Form
            </button>
            <span className="hidden sm:inline">|</span>
            <a href="https://www.uciny.com"
            className="hover:underline"
            target="_blank"
rel="noopener noreferrer">Company Website</a>
          </div>
 
          {/* Social Icons */}
          <div className="flex justify-center gap-6">
            {/* LinkedIn */}
            <a
              href="https://in.linkedin.com/company/unite-computech-info-india-pvt-ltd"
              aria-label="LinkedIn"
              className="hover:text-blue-600"
              target="_blank"
              rel="noopener noreferrer"
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 24 24"
                fill="currentColor"
                className="w-5 h-5"
              >
                <path d="M4.98 3.5C4.98 4.88 3.88 6 2.5 6S0 4.88 0 3.5 1.12 1 2.5 1s2.48 1.12 2.48 2.5zM.5 8.5h4V24h-4V8.5zm7 0h3.8v2.1h.1c.5-.9 1.8-1.9 3.7-1.9 4 0 4.7 2.6 4.7 6v9.3h-4V15.5c0-2.1 0-4.9-3-4.9s-3.4 2.3-3.4 4.8V24h-4V8.5z" />
              </svg>
            </a>
 
            {/* Mail */}
            <a
              href="mailto:donotreply@uciny.com"
              aria-label="Email"
              className="hover:text-red-500"
            >
              <Mail className="w-5 h-5" />
            </a>
          </div>
        </div>
 
        {/* Copyright & Logo */}
        <div className="flex flex-col sm:flex-row items-center justify-center gap-2 text-sm mt-2 pb-4">
          <span>© {year}</span>
          <div className="flex items-center gap-2">
            <img
              src="/images/uci-logo.png"
              alt="UCI Logo"
              width={20}
              height={20}
              className="rounded-full"
            />
            <span>{companyName}</span>
          </div>
        </div>
      </footer>
 
      {/* Feedback Modal */}
      <FeedbackModal
        isOpen={isFeedbackModalOpen}
        onClose={closeFeedbackModal}
      />
    </>
  )
}
 